import React from "react";
import "./scss/global.scss";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Auth from "./auth"
import NotFoundPage from "./pages/User/NotFoundPage";
import {RouteAdmin} from "./routes/RouteAdmin";
import {RouteAuth} from "./routes/RouteAuth";
import {RouteUser} from "./routes/RouteUser";
import {Helmet} from "react-helmet";
import CheckRole from "./components/Auth/CheckRole";
import LayoutUser from "./pages/User/Layouts/Basic";
import LayoutAdmin from "./components/Layouts/Admin";

export default function App() {

    return (
        <Router>
            <Auth>
                <Switch>
                    {Object.keys(RouteAuth).map((item, key) => {
                        const e = RouteAuth[item]
                        return (
                            <Route exact key={key} path={e.path} render={(props) => (
                                <>
                                    <Helmet>
                                        <title>{e.title}</title>
                                    </Helmet>

                                    <CheckRole roles={e.roles} />
                                    <e.page {...props} />
                                </>
                            )}/>
                        )
                    })}

                    {Object.keys(RouteUser).map((item, key) => {
                        const e = RouteUser[item]
                        return (
                            <Route exact key={key} path={e.path} render={(props) => (
                                <LayoutUser>
                                    <Helmet>
                                        <title>{e.title}</title>
                                    </Helmet>
                                    <CheckRole roles={e.roles} />
                                    <e.page {...props} />
                                </LayoutUser>
                            )}/>
                        )
                    })}

                    {Object.keys(RouteAdmin).map((item, key) => {
                        const e = RouteAdmin[item]
                        return (
                            <Route exact key={key} path={`${e.path}${e.params ?? ""}`} render={(props) => (
                                <LayoutAdmin menu={e.menu}>
                                    <Helmet>
                                        <title>{e.title}</title>
                                    </Helmet>
                                    <CheckRole roles={e.roles} />
                                    <e.page {...props} />
                                </LayoutAdmin>
                            )}/>
                        )
                    })}

                    <Route path='*' component={NotFoundPage}/>
                </Switch>
            </Auth>
        </Router>
    )
}
